import { Button } from '@/primitives/Button';

import styles from './ConfigurationButton.module.css';

type ConfigurationButtonProps = {
  label: string;
  onClick: () => void;
  icon?: React.JSX.Element;
  imagePath?: string;
  style?: React.CSSProperties;
  id?: string;
};

export const ConfigurationButton = ({
  label,
  onClick,
  icon,
  imagePath,
  style,
  id,
}: ConfigurationButtonProps) => {
  return (
    <Button
      onClick={onClick}
      icon={icon}
      className={styles.configurationButton}
      style={style}
      id={id}
    >
      <span className={styles.labelGroup}>
        {imagePath && <img src={imagePath} alt="" className={styles.preview} />}
        <strong>{label}</strong>
      </span>
    </Button>
  );
};
